import { ref, computed } from "vue";
import { defineStore } from "pinia";
import useMyFetch from "@stores/useMyFetch";
import type { AdsPage } from "@/types";

export const useAdsPagesStore = defineStore("adsPages", () => {
  const adsPages = ref<AdsPage[]>([]);

  const fetchAdsPages = async () => {
    const { data } = await useMyFetch("/ads_pages").json<{ ads_pages: AdsPage[] }>();
    adsPages.value = data.value?.ads_pages || [];
    return adsPages.value;
  };

  const facebookPageOptions = computed(() => {
    return adsPages.value
      .filter((page) => page.page_type === "facebook")
      .map((page) => ({ label: page.name, value: page.external_id }));
  });

  const instagramPageOptions = computed(() => {
    return adsPages.value
      .filter((page) => page.page_type === "instagram")
      .map((page) => ({ label: page.name, value: page.external_id }));
  });

  return {
    adsPages,
    fetchAdsPages,
    facebookPageOptions,
    instagramPageOptions,
  };
});
